import { z } from 'zod';
export const TIPOS_LIQUIDACION = ['INSTRUCTOR', 'PROMOTOR'];
export const ESTADOS_LIQUIDACION = ['BORRADOR', 'APROBADA', 'PAGADA', 'ANULADA'];
export const TIPOS_ITEM = [
    'HORAS_DICTADAS',
    'COMISION_SOLICITADO',
    'COMISION_PROMOTOR',
    'AJUSTE_MANUAL',
];
export const LiquidacionItemSchema = z.object({
    id: z.string().uuid(),
    tipo: z.string(),
    descripcion: z.string(),
    montoBase: z.union([z.string(), z.number()]).nullable().optional(),
    monto: z.coerce.number(),
    fechaReferencia: z.string(),
    reservaId: z.string().uuid().nullable().optional(),
    claseId: z.string().uuid().nullable().optional(),
    tramoId: z.string().uuid().nullable().optional(),
});
export const LiquidacionSchema = z.object({
    id: z.string().uuid(),
    codigo: z.string(),
    tipo: z.enum(TIPOS_LIQUIDACION),
    empleadoId: z.string().uuid().nullable().optional(),
    promotorId: z.string().uuid().nullable().optional(),
    personaNombre: z.string().nullable().optional(),
    rangoDesde: z.string(),
    rangoHasta: z.string(),
    total: z.coerce.number(),
    estado: z.enum(ESTADOS_LIQUIDACION),
    fechaGeneracion: z.string(),
    fechaAprobacion: z.string().nullable().optional(),
    fechaPago: z.string().nullable().optional(),
    observaciones: z.string().nullable().optional(),
    items: z.array(LiquidacionItemSchema).optional(),
});
const PaginacionSchema = z.object({
    total: z.number(),
    pagina: z.number(),
    porPagina: z.number(),
    totalPaginas: z.number(),
});
export const LiquidacionesPaginadasSchema = z.object({
    items: z.array(LiquidacionSchema),
    paginacion: PaginacionSchema,
});
export const GenerarLiquidacionSchema = z
    .object({
    tipo: z.enum(TIPOS_LIQUIDACION),
    personaId: z.string().uuid('Seleccioná una persona'),
    rangoDesde: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD'),
    rangoHasta: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD'),
    observaciones: z.string().max(2000).optional().or(z.literal('')),
})
    .refine((v) => v.rangoHasta >= v.rangoDesde, {
    path: ['rangoHasta'],
    message: 'La fecha hasta debe ser posterior a la fecha desde.',
});
export const AjusteManualSchema = z.object({
    descripcion: z.string().trim().min(1, 'Requerido').max(200),
    monto: z.string().regex(/^-?\d+(\.\d{1,2})?$/, 'Monto inválido'),
    fechaReferencia: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD')
        .optional()
        .or(z.literal('')),
});
